/* WebGLRenderer 的建立 —— 三個接縫之一。

   原本 `new THREE.WebGLRenderer(...)` 寫在模組層，import 即執行，Node 裡沒有
   WebGL context 會直接丟例外。改成由 initRenderer() 建立；headless 就不呼叫，
   renderer 保持 null，呼叫端自己擋掉。

   Three.js 的核心（Vector3 / Object3D / Group / 幾何體）在 Node 裡跑得起來，
   只有 WebGLRenderer 需要 context —— 所以隔開這一個東西就足以讓整個模擬 headless。 */

import * as THREE from 'three';

export var renderer: any = null;

export function initRenderer(mount: any) {
  renderer = new THREE.WebGLRenderer({ antialias: true, powerPreference: 'high-performance' });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
  if ((THREE as any).sRGBEncoding) renderer.outputEncoding = (THREE as any).sRGBEncoding;
  /* Tone mapping。**沒有它，emissive 1.7–2.2 超過 1.0 的部分會被 clamp**，
     琥珀 0xffb454 與青 0x5fe3ff 會一起趨白、掉失色相 —— 而發光是機體在
     遊戲鏡頭（約 60 像素高）下少數還讀得到的東西，這裡損失最大。
     代價是整體變暗，用 exposure 補回來。
     注意：`outputEncoding` 在 three r152 被 `outputColorSpace` 取代，
     本專案鎖 0.128 所以這行有效；升版時要一起重調。 */
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.05;
  /* 陰影。**只有機體投影**（`world/player.ts` 的 equipMech 逐一設 castShadow），
     300 隻敵人開陰影會讓 shadow map 每幀重繪一次全場。
     地面接收（`world/arena.ts`）。 */
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;
  if (mount) mount.appendChild(renderer.domElement);
  return renderer;
}
